var map = {
	"./back.png": 782,
	"./bonus-background.jpg": 783,
	"./bonus-circle.png": 784,
	"./bonus-head.png": 785,
	"./bonus-star.png": 786,
	"./effect-04.gif": 787,
	"./effect-05.png": 788,
	"./effect-06.gif": 789,
	"./jump.png": 790,
	"./lesson-backto11.png": 791,
	"./lesson-backto12.png": 792,
	"./lesson-backto13.png": 793,
	"./lesson-backto14.png": 794,
	"./lesson-backto15.png": 795,
	"./lesson-backward.png": 796,
	"./lesson-finish.png": 797,
	"./lesson-finish1.png": 798,
	"./lesson-forward.png": 799,
	"./lesson-lesson.jpg": 800,
	"./lesson-sound.png": 801,
	"./lesson-starnopass.png": 802,
	"./lesson-starpass.png": 803,
	"./lesson_sound.png": 804,
	"./toolbar_closetool.png": 805,
	"./toolbar_death_b_i.png": 806,
	"./toolbar_death_m_i.png": 807,
	"./toolbar_death_s_i.png": 808,
	"./toolbar_go_b.png": 809,
	"./toolbar_go_b_black_i.png": 810,
	"./toolbar_go_b_white_i.png": 811,
	"./toolbar_go_death_b.png": 812,
	"./toolbar_go_death_m.png": 813,
	"./toolbar_go_death_s.png": 814,
	"./toolbar_go_m.png": 815,
	"./toolbar_go_m_black_i.png": 816,
	"./toolbar_go_m_white_i.png": 817,
	"./toolbar_go_s.png": 818,
	"./toolbar_go_s_black_i.png": 819,
	"./toolbar_go_s_white_i.png": 820,
	"./toolbar_opentool.png": 821,
	"./toolbar_tool_clear.png": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;